import * as types from "~/store/totalData/types";

export const setTypeAction = value => {
  return {
    type: types.SET_TYPE_ACTION,
    value
  };
};

// reset thông tin CK, BS, DV đã chọn trước đó nếu có
export const resetBookingStepData = value => {
  return {
    type: types.RESET_BOOKING_STEP_DATE,
    value
  };
};

export const onLoading = () => {
  return {
    type: types.ON_LOADING
  };
};

export const offLoading = () => {
  return {
    type: types.OFF_LOADING
  };
};

// Set Partner ID
export const setPartnerId = id => {
  return {
    type: types.SET_PARTNER_ID,
    payload: id
  };
};

// Choose hospital
export const selectHospital = (id, hospital = {}) => {
  return {
    type: types.SELECT_HOSPITAL,
    payload: id,
    hospital
  };
};

// getBookingTree
export const getBookingTree = ({
  text = null,
  partnerId,
  selectTree,
  isAddNewSchedule = false,
  idBooking
}) => {
  return {
    type: types.GET_BOOKING_TREE,
    text,
    partnerId,
    selectTree,
    isAddNewSchedule,
    idBooking
  };
};

// SUBJECT
export const selectSubject = subject => {
  return {
    type: types.SELECT_SUBJECT,
    payload: subject
  };
};

export const resetSelectSubject = () => {
  return {
    type: types.RESET_SELECT_SUBJECT
  };
};

export const searchSubject = term => {
  return {
    type: types.SEARCH_SUBJECT,
    payload: term
  };
};

// SUBJECT
export const selectDoctor = doctor => {
  return {
    type: types.SELECT_DOCTOR,
    payload: doctor
  };
};

export const resetSelectDoctor = () => {
  return {
    type: types.RESET_SELECT_DOCTOR
  };
};

export const searchDoctor = term => {
  return {
    type: types.SEARCH_DOCTOR,
    payload: term
  };
};

// SERVICE
export const selectService = id => {
  return {
    type: types.SELECT_SERVICE,
    payload: id
  };
};
export const resetSelectService = () => {
  return {
    type: types.RESET_SELECT_SERVICE
  };
};
export const changeServiceType = serviceType => {
  return {
    type: types.CHANGE_SERVICE_TYPE,
    payload: serviceType
  };
};

// ROOM
export const selectRoom = id => {
  return {
    type: types.SELECT_ROOM,
    payload: id
  };
};
export const resetSelectRoom = () => {
  return {
    type: types.RESET_SELECT_ROOM
  };
};

// DATE
export const selectDate = date => {
  return {
    type: types.SELECT_DATE,
    payload: date
  };
};
export const resetSelectDate = () => {
  return {
    type: types.RESET_SELECT_DATE
  };
};

// TIME SLOT
export const selectTimeSlot = slot => {
  return {
    type: types.SELECT_TIME_SLOT,
    payload: slot
  };
};
export const resetSelectTimeSlot = () => {
  return {
    type: types.RESET_SELECT_TIME_SLOT
  };
};

// RESET ALL DATA
export const resetData = () => {
  return {
    type: types.RESET_DATA
  };
};

// BOOKING
export const reserveBooking = (referralCode = "") => {
  return {
    type: types.RESERVE_BOOKING,
    referralCode
  };
};
export const reserveBookingRePayment = (info = {}) => {
  return {
    type: types.RESERVE_BOOKING_REPAYMENT,
    info
  };
};
export const getPaymentInfo = (id, text = "", typePayment = 1) => {
  return {
    type: types.GET_PAYMENT_INFO,
    payload: id,
    text,
    typePayment
  };
};
export const getBookingInfo = ({ transactionId, text }) => {
  return {
    type: types.GET_BOOKING_INFO,
    payload: { transactionId, text }
  };
};

export const checkRepayment = status => {
  return {
    type: types.CHECK_REPAYMENT,
    payload: status
  };
};

// ADD SCHEDULE
export const addSchedule = () => {
  return {
    type: types.ADD_SCHEDULE
  };
};

export const addScheduleRepayment = ({ paymentInfo }) => {
  return {
    type: types.ADD_SCHEDULE_REPAYMENT,
    payload: {
      paymentInfo
    }
  };
};
export const resetSchedule = () => {
  return {
    type: types.RESET_SCHEDULE
  };
};

// Check Flow Forward or Back
export const changeDirection = status => {
  return {
    type: types.CHANGE_DIRECTION,
    layload: status
  };
};

// Medical Bills
export const getAllMedicalBills = () => {
  return {
    type: types.GET_ALL_MEDICAL_BILLS
  };
};

export const selectMedicalBill = (id, hospital = {}) => {
  return {
    type: types.SELECT_MEDICAL_BILL,
    payload: id,
    hospital
  };
};

// Repayment
export const repaymentBooking = () => {
  return {
    type: types.REPAYMENT_BOOKING
  };
};
export const changeBookingFlow = flow => {
  return {
    type: types.CHANGE_BOOKING_FLOW,
    flow
  };
};

// reset List node
export const resetListNode = node => {
  return {
    type: types.RESET_LIST_NODE,
    payload: node
  };
};

// reserve payment partner
export const reserveBookingPartner = () => {
  return {
    type: types.RESERVE_PAYMENT_PARTNER
  };
};

// go back step
export const goBackStep = node => {
  return {
    type: types.GO_BACK_STEP,
    node
  };
};

export const setInsuranceChoice = payload => {
  return {
    type: types.SET_INSURANCE_CHOICE,
    payload
  };
};

export const setScheduleWithoutDate = status => {
  return {
    type: types.SET_SCHEDULE_WITHOUT_DATE,
    payload: status
  };
};

export const setPaymentInfomationByCSKH = paymentInfo => {
  return {
    type: types.SET_PAYMENT_INFOMATION_BY_CSKH,
    payload: paymentInfo
  };
};

export const setAddonServices = id => {
  return {
    type: types.SET_ADDONSERVICES,
    id
  };
};

// SERVICE
export const selectRadioServiceAddOn = id => {
  return {
    type: types.SELECT_RADIO_SERVICE_ADDON,
    id
  };
};

export const resetAddOnService = () => {
  return {
    type: types.RESET_ADD_ON_SERVICE
  };
};

export const setGoBack = (value = true) => {
  console.log("value :>> ", value);
  return {
    type: types.SET_GO_BACK,
    value
  };
};

export const setFilterCheckData = id => {
  return {
    type: types.SET_FILTER_CHECK_DATA,
    id
  };
};

export const resetFilterCheckData = () => {
  return {
    type: types.RESET_FILTER_CHECK_DATA
  };
};

export const uploadFile = file => {
  return {
    type: types.UPLOAD_FILE,
    file
  };
};

export const getExtraConfig = (partnerId = "") => {
  return {
    type: types.GET_EXTRA_CONFIG,
    partnerId
  };
};

export const reserveMultipleBookings = (referralCode = "") => {
  return {
    type: types.RESERVE_MULTIPLE_BOOKINGS,
    referralCode
  };
};

export const removeSchedule = ({ indexSchedule }) => {
  return {
    type: types.REMOVE_SCHEDULE,
    payload: { indexSchedule }
  };
};

export const saveSheduleIndex = ({ indexSchedule }) => {
  return {
    type: types.SAVE_SCHEDULE_INDEX,
    payload: { indexSchedule }
  };
};

export const setPaymentInfoCSKH = payload => {
  return {
    type: types.BOOKING_INFO_CSKH_SUCCESS,
    payload
  };
};

export const reserveBookingCare247 = payload => {
  return {
    type: types.RESERVE_BOOKING_CARE_247,
    payload
  };
};

export const reserveBookingAddonCare247 = payload => {
  return {
    type: types.RESERVE_BOOKING_ADDON_CARE_247,
    payload
  };
};

// SELECT CARE247 ID
export const selectCare247ServiceId = id => {
  return {
    type: types.SELECT_CARE247_SERVICE,
    payload: id
  };
};

export const setHealthIndex = ({ height, weight }) => ({
  type: types.SET_HEALTH_INDEX,
  payload: { height, weight }
});

export const setNoteAssignment = noteAssignment => ({
  type: types.SET_NOTE_ASSIGNMENT,
  payload: noteAssignment
});
